import _ from 'lodash';
import * as actions from '../actions';

export const defaultState = {
  collapsed: true,
  isFocused: false,
  focusedResult: undefined,
  query: _.get(window, 'initialState.autocomplete.query'),
  resultsVisible: false,
  searchResults: {
    resultSetSize: 0,
    results: [],
    timings: {}
  }
};

function queryChanged(state, action) {
  const { query } = action;
  const searchResults = _.isEmpty(query) ? {} : state.searchResults;

  return { ...state, query, searchResults };
}

function resultsChanged(state, action) {
  // keep results empty if the query is empty
  const searchResults = _.isEmpty(state.query) ? { results: [] } : action.response;
  const visible = searchResults.results.length > 0 && state.isFocused;

  return { ...state, searchResults, resultsVisible: visible };
}

function resultVisibilityChanged(state, action) {
  const { visible } = action;

  // make sure we aren't focused on anything if we're hiding
  const focusedResult = visible ? state.focusedResult : undefined;

  // also, re-collapse when hiding
  const collapsed = visible ? state.collapsed : true;

  return { ...state, resultsVisible: visible, focusedResult, collapsed };
}

function focusedResultChanged(state, action) {
  const { focus } = action;
  const { searchResults } = state;
  const resultsEmpty = _.isEmpty(searchResults) || _.isEmpty(searchResults.results);

  let focusedResult;
  if (resultsEmpty || focus < 0) {
    // went above results or have no results; blank out focus
    focusedResult = undefined;
  } else if (focus >= searchResults.results.length - 1) {
    // past result set, go to end of results
    focusedResult = searchResults.results.length - 1;
  } else {
    focusedResult = focus;
  }

  return { ...state, focusedResult };
}

function clearFocusedResult(state) {
  return { ...state, focusedResult: undefined };
}

function collapseChanged(state, action) {
  return { ...state, collapsed: action.collapsed, focusedResult: undefined };
}

function clearSearch(state) {
  return { ...state, query: '' };
}

function focusChanged(state, isFocused) {
  //Maintains the component's state of focus
  //EN-35442: Used to determine result visibility in conditions where
  const collapsed = isFocused ? false : true;
  //results are updated after the user has blurred out of the component
  return { ...state, isFocused: isFocused, collapsed };
}

export default function(state = defaultState, action) {
  switch (action.type) {
    case actions.QUERY_CHANGED:
      return queryChanged(state, action);
    case actions.RESULTS_CHANGED:
      return resultsChanged(state, action);
    case actions.RESULT_VISIBILITY_CHANGED:
      return resultVisibilityChanged(state, action);
    case actions.RESULT_FOCUS_CHANGED:
      return focusedResultChanged(state, action);
    case actions.CLEAR_FOCUSED_RESULT:
      return clearFocusedResult(state);
    case actions.COLLAPSE_CHANGED:
      return collapseChanged(state, action);
    case actions.CLEAR_SEARCH:
      return clearSearch(state);
    case actions.FOCUS_CHANGED:
        return focusChanged(state, action.isFocused);
    default:
      return state;
  }
}
